module.exports = __webpack_public_path__ + "static/media/contadinoGreen.ef7c6620.png";